module.exports = __webpack_public_path__ + "img/about-company-06.a33264fa.webp";